// Module
var code = "<wt-generic-search-bar criteria=\"vm.criteria\" filtered-items=\"vm.filtered\" items=\"vm.viewModels\" placeholder=\"Search for units (al:alias c:comment u:unit v:variable vst:sub-type)\"> </wt-generic-search-bar>";
// Exports
module.exports = code;